import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group errors" }

import { computed, reactive } from 'vue';
import { useEditModalCommon } from 'src/composables/useEditModalCommon';
import type { AdminGroup2 } from 'src/models/group2';
import type { AdminGroup3Params } from 'src/models/apis/group3/adminGroup3Request';
import type { Group3InputModel } from 'src/models/group3';
import { createGroup3InitInputModel } from 'src/models/group3';


export default /*@__PURE__*/_defineComponent({
  __name: 'Group3EditModal',
  props: {
    isEditMode: { type: Boolean },
    group3: {},
    groups2: {},
    isRequesting: { type: Boolean },
    httpErrorMsgs: {}
  },
  emits: ["create", "update", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<{ group3: Group3InputModel }>({
  group3: createGroup3InitInputModel(),
});

const { editModalTitle } = useEditModalCommon(props, () => props.group3, (copied) => {
  state.group3 = copied;
});

const validateGroup3Form = (group3: Group3InputModel): boolean => {
  if (!Number.isInteger(group3.parentId)) return false;
  if (group3.name.length <= 0) return false;
  if (group3.dispOrder && !/^\d+$/.test(group3.dispOrder.toString())) return false;

  return true;
};

const isSaveButtonDisabled = computed<boolean>(() => {
  return props.isRequesting || !validateGroup3Form(state.group3);
});

const toPayload = (): AdminGroup3Params => {
  return {
    name: state.group3.name,
    parent_id: state.group3.parentId,
    disp_order: Number(state.group3.dispOrder),
  };
};

const createGroup3 = (): void => {
  if (isSaveButtonDisabled.value) return;

  emit('create', toPayload());
};

const updateGroup3 = (): void => {
  if (isSaveButtonDisabled.value || state.group3.id === null) return;

  emit('update', state.group3.id, toPayload());
};

const save = (): void => {
  if (props.isEditMode) {
    updateGroup3();
  } else {
    createGroup3();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: _unref(editModalTitle),
    "bottom-close-button-label": "保存",
    isCloseButtonDisabled: isSaveButtonDisabled.value,
    onClose: save,
    onDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-control-label" }, "事業所", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.group3.parentId) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groups2, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.id,
                value: e.id
              }, _toDisplayString(e.name), 9, _hoisted_2))
            }), 128))
          ], 512), [
            [_vModelSelect, state.group3.parentId]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-control-label" }, " 部署名 ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.group3.name) = $event))
          }, null, 512), [
            [_vModelText, state.group3.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-control-label" }, " 表示順 ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.group3.dispOrder) = $event))
          }, null, 512), [
            [_vModelText, state.group3.dispOrder]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.httpErrorMsgs, (e, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "error",
              key: i
            }, _toDisplayString(e), 1))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isCloseButtonDisabled"]))
}
}

})